module.exports = __webpack_public_path__ + "img/s7Model2.822bd060.webp";